import { render } from "./ActionsCards.vue?vue&type=template&id=c8007a20"
import script from "./ActionsCards.vue?vue&type=script&lang=js"
export * from "./ActionsCards.vue?vue&type=script&lang=js"

import "./ActionsCards.vue?vue&type=style&index=0&id=c8007a20&lang=scss"

import exportComponent from "C:\\Users\\Florian\\Work\\Sportips\\NOUVEAUX MODULES\\inscription\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__